module.exports = __webpack_public_path__ + "img/img-alertV2_ok_1195f.png";